import React, { useState } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const CustomPagination = ({
  total,
  current = 1,
  setCurrent,
  onClick,
  limit = 10,
}) => {
  const pages = Math.ceil(total / limit);
  const totalNumArray = Array(pages)
    .fill("")
    .map((tot, i) => i + 1);

  const [offset, setOffset] = useState(1);

  return (
    <Pagination aria-label="Page navigation example">
      {offset > 1 && (
        <PaginationItem
          onClick={() => {
            setOffset((prev) => (prev -= 1));
          }}
        >
          <PaginationLink previous href="#" />
        </PaginationItem>
      )}
      {/* <PaginationItem>
        <PaginationLink previous href="#" />
      </PaginationItem> */}

      {totalNumArray
        ?.slice((offset - 1) * limit, limit * offset)
        ?.map((num) => (
          <PaginationItem
            active={num === current}
            onClick={() => {
              if (onClick) {
                onClick(num);
              }
              setCurrent(num);
            }}
          >
            <PaginationLink>{num}</PaginationLink>
          </PaginationItem>
        ))}

      {pages >= offset * limit + 1 && (
        <PaginationItem
          onClick={() => {
            setOffset((prev) => (prev += 1));
          }}
        >
          <PaginationLink next href="#" />
        </PaginationItem>
      )}
      {/* <PaginationItem>
        <PaginationLink next href="#" />
      </PaginationItem>
      <PaginationItem>
        <PaginationLink last href="#" />
      </PaginationItem> */}
    </Pagination>
  );
};

export default CustomPagination;
